export const FETCH_DATA_API = 'FETCH_DATA_API';
export const FETCH_DATA_API_SUCCESS = 'FETCH_DATA_API_SUCCESS';
export const FETCH_DATA_API_ERROR = 'FETCH_DATA_API_ERROR';
export const FETCH_DATA_LOCAL = 'FETCH_DATA_LOCAL';
export const GET_FILTER_DATA = 'GET_FILTER_DATA';
export const FILTER_THE_DATA = 'FILTER_THE_DATA';